import { RampInstantEventTypes, RampInstantSDK } from "@ramp-network/ramp-instant-sdk";
import { useStoreUserV2 } from "@/stores/storeUserV2";
import { useStoreApp, NotifType } from "@/stores/storeApp";
import { isProd, LOGO_URL, maticMinAmount, rampApiKey } from "@/application/config";
import { pinia } from "~/main";
import { IAuctionItem } from "~/common/interfaces/IMarketplace";
import { useWeb3AuthStore } from "@/stores/storeWeb3auth";

export const useRamp = () => {
  const storeApp = useStoreApp();

  const showOverlay = (input: { device: "desktop" | "mobile"; mode: "buy" | "sell" }) => {
    const storeUser = useStoreUserV2(pinia);
    const web3AuthStore = useWeb3AuthStore(pinia);
    const { device, mode } = input;

    let walletAddress = web3AuthStore.walletAddress;
    if (
      storeUser.smartWalletAddress &&
      web3AuthStore.smartWalletAddress?.toLowerCase() ===
        storeUser.smartWalletAddress?.toLowerCase()
    ) {
      walletAddress = web3AuthStore.smartWalletAddress;
    }
    const ramp = new RampInstantSDK({
      hostAppName: "fungiball",
      fiatCurrency: "EUR",
      enabledCryptoAssets: ["MATIC_USDC", "MATIC_POL"],
      // defaultAsset: storeUser.currentMaticBalance < maticMinAmount ? "MATIC_POL" : "MATIC_POL",
      // swapAsset:
      //   storeUser.currentMaticBalance < maticMinAmount ? "MATIC_POL" : "MATIC_POL,MATIC_POL",
      url: isProd ? undefined : "https://app.demo.ramp.network",
      enabledFlows: mode === "buy" ? ["ONRAMP"] : ["OFFRAMP"],
      hostLogoUrl: LOGO_URL,
      hostApiKey: rampApiKey,
      userAddress: walletAddress,
      userEmailAddress: storeUser.email,
      variant: device,
    }).show();

    ramp.on(RampInstantEventTypes.PURCHASE_CREATED, (event) => {
      const status = event.payload.purchase.status;

      switch (status) {
        case "PAYMENT_FAILED":
          storeApp.displayNotification(NotifType.FUNDS_DEPOSIT_FAILED, {} as IAuctionItem);
          break;

        case "PAYMENT_EXECUTED":
          storeApp.displayNotification(NotifType.FUNDS_DEPOSIT_SUCCESS, {} as IAuctionItem);
          break;

        default:
          break;
      }
    });
  };

  return {
    showOverlay,
  };
};
